const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/staff-schedule.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/staff-schedule')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// ─── Types ──────────────────────────────────────────────────────────────────

interface Member {
  id: string;
  displayName: string | null;
  inviteEmail: string;
  status: string;
  roleName: string;
}
interface ScheduleSlot {
  id: string;
  memberId: string;
  memberName: string;
  locationId: string | null;
  dayOfWeek: number;
  specificDate: string;
  startTime: string;
  endTime: string;
  type: 'shift' | 'availability' | 'time-off';
  timeOffType: string;
  seriesId: string | null;
  notes: string;
}
type FormType = 'shift' | 'availability' | 'time-off';
type TimeOffSubType = 'vacation' | 'sick' | 'personal' | 'unavailable' | 'holiday';

// ─── Constants ──────────────────────────────────────────────────────────────

// 6am to 9pm

// ─── Helpers ────────────────────────────────────────────────────────────────

// ─── Component ──────────────────────────────────────────────────────────────

// ─── Modal overlay ────────────────────────────────────────────────────────